module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/floating-btn-f5b9fc4061d9330825d48cdb97d9fd72.png";